import styled from "styled-components";

interface ProjectFormLayoutProps {
  title: string;
  children: any;
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const Title = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 40px;
`;

const ProjectFormLayout = ({ title, children }: ProjectFormLayoutProps) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      {children}
    </Wrapper>
  );
};

export default ProjectFormLayout;
